'use strict';

var keys = require('./keys.js');

function getTranslationKey(validationError, name) {
    if (validationError.contexts != null) {
        for (const context of Object.values(validationError.contexts)) {
            const typedContext = context;
            if (typedContext.translationKey != null &&
                typedContext.translationKey !== '') {
                return typedContext.translationKey;
            }
        }
    }
    return `validation${name[0].toUpperCase()}${name.slice(1)}`;
}
function createValidationPointersFromClassValidator(validationErrors) {
    /* eslint-disable @typescript-eslint/no-unsafe-assignment */
    var _a;
    const result = {};
    for (const validationError of validationErrors) {
        const { constraints, property, value, contexts = {} } = validationError;
        const fieldName = property;
        if (result[fieldName] === undefined) {
            result[fieldName] = [];
        }
        const validationMessages = result[fieldName];
        let errors = [];
        if (value == null &&
            ((constraints === null || constraints === void 0 ? void 0 : constraints.isDefined) != null || (constraints === null || constraints === void 0 ? void 0 : constraints.isNotEmpty) != null)) {
            errors = [
                {
                    translationKey: getTranslationKey(validationError, 'isDefined'),
                    message: (_a = constraints.isDefined) !== null && _a !== void 0 ? _a : constraints.isNotEmpty,
                    arguments: {},
                },
            ];
        }
        else if (constraints != null) {
            errors = Object.keys(constraints).map((key) => ({
                translationKey: getTranslationKey(validationError, key),
                message: constraints[key],
                arguments: Object.assign(Object.assign({}, contexts[key]), { value }),
            }));
        }
        if (validationMessages !== undefined) {
            validationMessages.push(...errors);
        }
    }
    return result;
    /* eslint-enable @typescript-eslint/no-unsafe-assignment */
}
function getValidationPointerMessages(fieldName, validationPointers) {
    const validationMessages = validationPointers[fieldName];
    if (validationMessages !== undefined) {
        return validationMessages;
    }
    return [];
}
function setValidationPointerMessages(fieldName, messages, validationPointers) {
    validationPointers[fieldName] = messages;
}
function addValidationPointerMessages(fieldName, messages, validationPointers) {
    const validationMessages = validationPointers[fieldName];
    if (validationMessages === undefined) {
        validationPointers[fieldName] = [...messages];
    }
    else {
        validationMessages.push(...messages);
    }
}
function mergeValidationPointers(...validationPointers) {
    const result = {};
    for (const validationPointer of validationPointers) {
        for (const fieldName of keys.keys(validationPointer)) {
            result[fieldName] = [
                ...getValidationPointerMessages(fieldName, result),
                ...getValidationPointerMessages(fieldName, validationPointer),
            ];
        }
    }
    return result;
}

exports.addValidationPointerMessages = addValidationPointerMessages;
exports.createValidationPointersFromClassValidator = createValidationPointersFromClassValidator;
exports.getValidationPointerMessages = getValidationPointerMessages;
exports.mergeValidationPointers = mergeValidationPointers;
exports.setValidationPointerMessages = setValidationPointerMessages;
//# sourceMappingURL=validationPointers.js.map
